'use client';

import { useEffect } from 'react';
import { getInplAppWebviewFlag } from '../../frontastic/helper/feature-flag-helper';

export default function AutoTruyoConsent() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const attStatus = params.get('att_status');
    const shouldDecline = attStatus === 'denied';
    const shouldAccept = attStatus === 'authorized';
    const isMobileView = getInplAppWebviewFlag();
    if (!isMobileView) return;
    const observer = new MutationObserver(() => {
      const consentModule = document.getElementById('truyo-consent-module');
      const acceptButton = document.getElementById('acceptAllCookieButton');
      const declineButton = document.getElementById('declineAllCookieButton');
      if (consentModule && isMobileView) {
        if (shouldDecline && declineButton) {
          declineButton.click();
          observer.disconnect();
        } else if (shouldAccept && acceptButton) {
          acceptButton.click();
          observer.disconnect();
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  return null;
}
